import type { Order } from "@bioflow/contracts";
import { ChevronRight, PackageOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useOrders } from "../api/hooks";
import { NeedTelegram } from "../components/NeedTelegram";
import { StatusBadge } from "../components/OrderParts";
import { profile as text } from "../content/site";
import { formatDate, formatMoney, formatOrderNumber } from "../lib/money";
import { hasTelegramContext } from "../lib/telegram";

/** Строка заказа — в списке «Мои заказы» и в профиле. */
export function OrderRow({ order }: { order: Order }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="row" onClick={() => navigate(`/orders/${encodeURIComponent(order.orderNumber)}`)}>
      <div className="row__body">
        <div className="row__between">
          <div className="row__title">{formatOrderNumber(order.orderNumber)} · {order.items[0]?.productTitle ?? "Tirzepatide"}</div>
          <strong>{formatMoney(order.total)}</strong>
        </div>
        <div className="row__between">
          <StatusBadge status={order.status} />
          <span className="row__meta">{formatDate(order.placedAt)}</span>
        </div>
      </div>
      <ChevronRight size={18} strokeWidth={1.8} aria-hidden className="row__chevron" />
    </button>
  );
}

export function OrdersScreen() {
  const navigate = useNavigate();
  const orders = useOrders();

  if (!hasTelegramContext()) return <NeedTelegram what="Список заказов" />;
  if (orders.isPending) return <div className="state">Загружаем заказы…</div>;
  if (orders.isError) return <div className="state">Не удалось загрузить заказы. Попробуйте позже.</div>;

  if (orders.data.items.length === 0) {
    return (
      <div className="state">
        <PackageOpen size={32} strokeWidth={1.4} aria-hidden />
        <div>{text.noOrders}</div>
        <button type="button" className="button button--ghost button--inline" onClick={() => navigate("/")}>
          К товару
        </button>
      </div>
    );
  }

  return (
    <div className="screen screen--plain">
      <h1 className="screen__title">{text.ordersTitle}</h1>
      <p className="screen__subtitle">{text.ordersSubtitle}</p>
      {orders.data.items.map((order) => (
        <OrderRow key={order.orderNumber} order={order} />
      ))}
    </div>
  );
}
